var React = require('react');

function AddCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("line",{"className":"a","x1":"12","y1":"7.5","x2":"12","y2":"16.5","key":1}),React.createElement("line",{"className":"a","x1":"7.5","y1":"12","x2":"16.5","y2":"12","key":2}),React.createElement("circle",{"className":"a","cx":"12","cy":"12","r":"11.25","key":3})]);
}

AddCircle.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = AddCircle;

AddCircle.default = AddCircle;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/add-circle.svg
// module id = 1056
// module chunks = 0